const comparator = (a, b) => {
    let result = void 0;
    if (typeof b === 'string') {
        result = b.localeCompare(a);
    } else {
        result = a > b ? -1 : a < b ? 1 : 0;
    }
    return result;
};

export const sortFunc = (dataField, order, rowA, rowB) => {
    let result = 0;
    let a = rowA[dataField];
    let b = rowB[dataField];

    if (dataField === 'securityGroup') {
        a = a && a['name'];
        b = b && b['name'];
    }
    if (dataField === 'statusDate') {
        const dateA = a ? new Date(a) : null;
        const dateB = b ? new Date(b) : null;
        result = order === 'asc'
            ? dateA ? dateB ? dateA.getTime() - dateB.getTime() : -1 : 1
            : dateB ? dateA ? dateB.getTime() - dateA.getTime() : 1 : -1;
    } else {
        result = order === 'desc' ? comparator(a, b) : comparator(b, a);
    }
    return result;
};

